import { classMap, html } from '@resn/gozer-core';
import { map, lerp } from '@resn/gozer-math';
import { autobind } from 'core-decorators';

import { Component, componentMixin } from '@resn/gozer-core/component';
import { PAGE_DATA } from 'data/page-data';

import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import WithRouter from '@resn/gozer-core-mixins/with-router';
import Analytics from '@resn/gozer-core/analytics';
import { isMobile } from '@resn/gozer-env';

import './index.scss';
import store from 'core/store';
import gsap from 'gsap/gsap-core';
import svg from 'component/svg';
import ScrollService from 'utils/services/scroll-service';
import ShopifyService from 'api/shopify';

import BtnMain from 'component/btn-main';
import HeaderCenter from './header-center ';
import CloseButton from './btn-close';
import MenuButton from './btn-menu';
import { navigate } from 'utils/router-utils';
import config from '@resn/gozer-core/config';
import { COLORS } from 'core/constants';

const template = ({ props, context }) => html`
    <header class="menu__header  header ${classMap({
        visible: props.visible,
        hideUi: props.hideUi,
        showBg: props.showBg,
    })}"
        data-ui="header">
        <div class="header__background"></div>
        <div class="header__inner maxWidth ${!isMobile ? 'grid' : ''}" data-ui='inner'>
            <div class="header__border"></div>
            <div class="header__left" @click="${context.onHeaderLogoClick}">
                ${svg('oxefit-logo-full-color', 'header__logo')}
            </div>
            <nav class="${props.isConfigureXs1Page ? 'displayNone' : null} header__center  text-mainNav" data-ui='center'>
                <div class="header__centerInner  header__uiInner" data-ui='centerInner'></div>
            </nav>
            <div class="header__innerground"></div>
            <div class="${props.isConfigureXs1Page ? 'displayNone' : null} header__right">
                <div class="header__orderBtnWrap">
                    <div class="header__orderBtnOuter  header__uiInner" data-ui="btnWrap"></div>
                </div>
                <nav class="header__nav" data-ui="nav"></nav>
            </div>


    </header>
`;

@componentMixin(WithRouter)
@componentMixin(DomComponentMixin)
class Header extends Component {
    options = {
        template,
        onMenu: () => {},
        onClose: () => {},
    };

    props = {
        open: false,
        visible: false,
        scrolling: false,
        page: () => store().state.route.page,

        aboveFold: (props) => store().state.scroll < props.bannerH, //ResizeService.windowHeight,

        menuOverride: () => store().state.header.menuOverride,
        bgAboveFold: () => store().state.header.bgAboveFold,
        bgColor: () => store().state.header.bgColor,
        textColorAboveFold: () => store().state.header.textColorAboveFold,
        textColorBelowFold: () => store().state.header.textColorBelowFold,

        textColor: (props) =>
            props.menuOverride ? 'white' : props.aboveFold ? props.textColorAboveFold : props.textColorBelowFold,
        showBg: (props) => !props.menuOverride && ((props.aboveFold && props.bgAboveFold) || !props.aboveFold),
        hideUi: (props) => props.menuOverride || props.page === PAGE_DATA.ACCOUNT.name,

        isConfigureXs1Page: () => store().state.route.pathname === PAGE_DATA.CONFIGURE.XS1,

        menuActive: () => store().state.menu.open,
        bannerH: () => store().state.promoBannerHeight,
        yScroll: (props) =>
            store().state.showPromoBanner ? map(store().state.scroll, 0, props.bannerH, props.bannerH, 0, true) : 0,
        y: (props) => lerp(store().state.headerRetractPr, props.yScroll, 0),
    };

    async onSetup() {
        await this.createCenter();
        await this.createButtons();

        this.tweens = { headerRetractPr: 0 };
    }

    setY(val) {
        this.el.style.transform = `translateY(${val}px)`;
    }

    setMenuActive(val) {
        gsap.killTweensOf(this.tweens);
        gsap.to(this.tweens, {
            duration: 0.3,
            ease: 'power2.out',
            headerRetractPr: val ? 1 : 0,
            onUpdate: () => (store().state.headerRetractPr = this.tweens.headerRetractPr),
        });
    }

    @autobind
    onClick() {}

    setBgColor(val) {
        this.el.style.setProperty('--bgColor', val);
    }

    setTextColor(val) {
        this.el.style.setProperty('--textColor', val);
    }

    // setShowBg(val) {
    //     this.el.style.setProperty('--showBg', val);
    // }

    async createCenter() {
        this.center = await new HeaderCenter().setup({
            options: {
                el: this.ui['centerInner'],
                navigateTo: this.options.navigateTo,
            },
            props: {},
        });
    }

    async createButtons() {
        const { state } = store();

        await new BtnMain().setup({
            options: {
                className: 'header__orderBtn',
                small: true,
                appendTo: this.ui.btnWrap,
                onClick: () => {
                    window.open(PAGE_DATA.SCHEDULE_DEMO.XS1, '_blank') || window.location.assign(PAGE_DATA.SCHEDULE_DEMO.XS1);
                }
            },
            props: {
                bgColor:  COLORS.ORANGE,
                text: (isMobile) ? 'Demo' :'Schedule Demo',
                iconId: (isMobile) ? null : 'arrowhead-right',
            },
        })

        this.btnOrder = await new BtnMain().setup({
            options: {
                className: 'header__orderBtn',
                appendTo: this.ui.btnWrap,
                small: true,
                onClick: () => {
                    if (isMobile) navigate(PAGE_DATA.SHOP.path);
                    else if (this.btnOrder.props.isXS1) navigate(PAGE_DATA.CONFIGURE.XS1);
                    else navigate(PAGE_DATA.CONFIGURE.XP1);
                },
            },
            props: {
                disabled: () => state.route.page.includes('configure') && !isMobile,
                isXS1: () => !state.route.pathname.includes('xp1'),
                text: (props) => (isMobile ? 'Shop' : props.isXS1 ? 'Configure XS1' : 'Configure XP1'),
                bgColor: (props) => (props.isXS1 ? COLORS.ELECTRIC_BLUE : COLORS.ORANGE),
                textColor: 'white',
                iconId: () => (isMobile || state.route.page.includes('configure') ? null : 'arrowhead-right'),
            },
        });

        this.btnMenu = await new MenuButton().setup({
            options: {
                appendTo: this.ui.nav,
                handlerClick: this.options.onMenu,
            },
            props: {
                open: () => !this.props.open,
            },
        });

        this.closeMenu = await new CloseButton().setup({
            options: {
                appendTo: this.ui.nav,
                handlerClick: this.options.onClose,
            },
            props: {
                open: () => this.props.open,
            },
        });
    }

    // state ----------------------------------------------

    // onOpen() {}
    // offOpen() {}

    // handlers ----------------------------------------------

    @autobind
    onHeaderLogoClick(e) {
        e.preventDefault();
        Analytics.trackEvent('Header', 'click', 'Header Logo');

        if (store().state.route.page !== 'home') {
            navigate('/');
        } else {
            this.props.open = false;

            gsap.killTweensOf(ScrollService, 'scroll');
            gsap.to(ScrollService, {
                scroll: 0,
                duration: 1,
                ease: 'expo.out',
                onStart: () => (this.props.scrolling = true),
                onComplete: () => (this.props.scrolling = false),
            });
        }
    }

    resize() {
        store().state.navHeight = this.el.clientHeight;

        if (this.center) this.center.resize();
    }
}

export default Header;
